import { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileNav } from './MobileNav';

export function AppShell() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <Flex minH="100dvh" bg="bg.canvas">
      <Sidebar />
      <MobileNav open={navOpen} onOpenChange={setNavOpen} />
      <Flex direction="column" flex="1" minW={0}>
        <TopBar onOpenNav={() => setNavOpen(true)} />
        <Box as="main" flex="1" minW={0} minH={0} display="flex" flexDirection="column">
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  );
}
